
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agriculture",
      function () {
        return require("private-next-pages/agriculture.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agriculture"])
      });
    }
  